import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const AssignOrder = async (payload) => {
  return await httpRequest(`${BASE_URL}/orders/AssignAgentToOrder`, "patch", payload );
}
export const ChangeOrderStatus = async (payload) => {
  return await httpRequest(`${BASE_URL}/Orders/ChangeOrderStatus`, "patch", payload );
}
export const Order = async (payload) => {
  return await httpRequest(`${BASE_URL}/Orders/${payload}`, "get" );
}
